import { api } from "@/lib/api";

interface PublicConfig {
  recaptcha: { enabled: boolean; site_key?: string };
}

declare global {
  interface Window {
    grecaptcha?: {
      enterprise: {
        ready(callback: () => void): void;
        execute(siteKey: string, options: { action: string }): Promise<string>;
      };
    };
  }
}

let configPromise: Promise<PublicConfig> | null = null;
let scriptPromise: Promise<void> | null = null;

function publicConfig() {
  configPromise ??= api<PublicConfig>("/public/config");
  return configPromise;
}

function loadScript(siteKey: string) {
  if (window.grecaptcha?.enterprise) return Promise.resolve();
  scriptPromise ??= new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error("Submission protection did not load."));
    document.head.appendChild(script);
  });
  return scriptPromise;
}

export async function recaptchaToken(action: string) {
  const config = await publicConfig();
  const siteKey = config.recaptcha.site_key;
  if (!config.recaptcha.enabled || !siteKey) return undefined;

  await loadScript(siteKey);
  const enterprise = window.grecaptcha?.enterprise;
  if (!enterprise) throw new Error("Submission protection did not load.");

  await new Promise<void>((resolve) => enterprise.ready(resolve));
  return enterprise.execute(siteKey, { action });
}
